import(/* webpackMode: "eager" */ "/tmp/8dec0e1e312ed8b/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dec0e1e312ed8b/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dec0e1e312ed8b/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dec0e1e312ed8b/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dec0e1e312ed8b/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dec0e1e312ed8b/src/styles/global.scss");
